import React, { useEffect, useState } from "react";
import { OtService } from "../services/OtService";

export const PanelAlertasPreventivo: React.FC = () => {
  const [ordenes, setOrdenes] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const cargar = async () => {
    setIsLoading(true);
    try {
      const data = await OtService.fetchAlertasPreventivo();
      setOrdenes(data);
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    cargar();
  }, []);

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
        <h2 className="mb-0">
          <i className="fas fa-exclamation-triangle text-warning me-2"></i>
          Alertas de precio — Preventivo
        </h2>
        <button type="button" className="btn btn-outline-primary btn-sm" onClick={cargar} disabled={isLoading}>
          <i className="fas fa-sync-alt me-1"></i> Actualizar
        </button>
      </div>

      <p className="text-muted small mb-3">
        Órdenes con un solo concepto PREVENTIVOS cuyo monto cotizado quedó fuera de la tolerancia del umbral parametrizado.
      </p>

      <div className="card shadow-sm border-0">
        <div className="table-responsive">
          <table className="table table-hover align-middle mb-0">
            <thead>
              <tr>
                <th>OT Folio</th>
                <th>Bien</th>
                <th>Taller (RFC)</th>
                <th>F. Alta</th>
                <th>Ejecutivo</th>
                <th className="text-end">Monto cotizado</th>
                <th className="text-end">Umbral ref.</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan={8} className="text-center py-5">
                    <div className="spinner-border text-warning"></div>
                  </td>
                </tr>
              ) : ordenes.length === 0 ? (
                <tr>
                  <td colSpan={8} className="text-center py-5 text-muted">
                    No hay alertas de preventivo activas.
                  </td>
                </tr>
              ) : (
                ordenes.map((ot) => (
                  <tr key={ot.clave_orden_trabajo}>
                    <td>
                      <strong>{ot.folio}</strong>
                    </td>
                    <td>
                      {ot.nombre_bien}
                      <br />
                      <small className="text-muted">
                        {ot.numero_serie} - {ot.placa}
                      </small>
                    </td>
                    <td>
                      {ot.taller}
                      <br />
                      <small className="text-muted">{ot.rfc}</small>
                    </td>
                    <td>{(ot.fecha_alta || "").split(" ")[0]}</td>
                    <td>{ot.usr_asignado}</td>
                    <td className="text-end fw-bold">
                      ${Number(ot.monto_cotizado || 0).toLocaleString("es-MX", { minimumFractionDigits: 2 })}
                    </td>
                    <td className="text-end">
                      ${Number(ot.monto_referencia_preventivo || 0).toLocaleString("es-MX", { minimumFractionDigits: 2 })}
                    </td>
                    <td>
                      <a
                        href={`/solicitudServicio?accion=edit&id=${btoa(String(ot.clave_solicitud_servicio))}`}
                        className="btn btn-sm btn-warning"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="far fa-eye"></i>&nbsp;
                        <span className="d-none d-md-inline">Revisar</span>
                      </a>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PanelAlertasPreventivo;
